import React from 'react';
import { Droplet, Beef, AlertTriangle, Brain } from 'lucide-react';
import { motion } from 'framer-motion';
import { TomosAccordion } from '../ui/TomosAccordion';
import { BonosAccordion } from '../ui/BonosAccordion';
const highlights = [{
  icon: <Droplet size={24} data-id="element-59" />,
  title: 'Calculadora de Hidratación Diaria',
  desc: 'Sabé exactamente cuánta agua y electrolitos necesitas según tu peso, clima y volumen de entrenamiento.'
}, {
  icon: <Beef size={24} data-id="element-60" />,
  title: 'Calculadora de Proteínas',
  desc: 'Ajustá tu ingesta proteica para optimizar la recuperación muscular sin pasarte ni quedarte corto.'
}, {
  icon: <AlertTriangle size={24} data-id="element-61" />,
  title: 'Suplementos a Evitar y Validados',
  desc: 'Lista clara y honesta de qué suplementos sí funcionan y cuáles son una pérdida de plata.'
}, {
  icon: <Brain size={24} data-id="element-62" />,
  title: 'Psicología Deportiva',
  desc: 'Herramientas mentales para mantener la motivación, gestionar la presión y rendir cuando más importa.'
}];
export function Includes() {
  return <section className="py-24 bg-black" data-id="element-63">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="text-center mb-16" data-id="element-65">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-66">
            ¿Qué incluye el sistema?
          </h2>
          <p className="text-lg text-white/70 max-w-2xl mx-auto" data-id="element-67">
            Todo lo que necesitas para cruzar la meta, organizado en un solo
            lugar.
          </p>
        </div>

        <TomosAccordion data-id="element-68" />

        <div className="text-center mb-12" data-id="element-69">
          <span className="inline-block px-3 py-1 bg-brand-green/15 text-brand-green text-xs font-bold tracking-wider uppercase rounded-full mb-4" data-id="element-70">
            Contenido destacado del ebook
          </span>
          <h3 className="font-serif text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-71">
            Herramientas exclusivas dentro del libro
          </h3>
          <p className="text-white/70 max-w-2xl mx-auto" data-id="element-72">
            No es solo teoría. Vas a tener calculadoras prácticas y guías
            validadas para aplicar desde el día uno.
          </p>
        </div>

        <div className="mb-16" data-id="element-73">
          <BonosAccordion data-id="element-74" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-75">
          {highlights.map((h, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-brand-green text-brand-dark rounded-2xl p-7" data-id="element-76">
              <div className="w-12 h-12 rounded-xl bg-brand-dark/10 text-brand-dark flex items-center justify-center mb-5" data-id="element-77">
                {h.icon}
              </div>
              <h4 className="text-lg font-bold mb-3" data-id="element-78">{h.title}</h4>
              <p className="text-brand-dark/80 leading-relaxed text-sm" data-id="element-79">
                {h.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}